import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const BETTINGWEBSITEFEATUREGQLSCHEMA = `
id
Feature{
    ${MULTILANGUAGEGQLSCHEMA}
}
`;
